import { Icon, IconName } from "@silversea-ssc/ui-components-react"
import React, { ReactElement, useEffect, useRef, useState } from "react"

import clsx from "clsx"
import InnerSectionContainer from "../InnerSectionContainer/InnerSectionContainer"
import styles from "./PageBanner.module.scss"

type Props = {
    iconName: IconName
    button?: ReactElement
    dataContentName: string
    spacingBottom?: boolean
    withBorder?: boolean
}

const PageBanner: React.FC<React.PropsWithChildren<Props>> = ({
    dataContentName,
    iconName,
    button,
    children,
    spacingBottom,
    withBorder,
}) => {
    const [isSticky, setIsSticky] = useState(false)
    const notReadyToBookRef = useRef<HTMLDivElement>(null)
    const placeholderRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        const handleScroll = () => {
            if (!placeholderRef.current) return
            const { top } = placeholderRef.current.getBoundingClientRect()

            if (top < 0) {
                setIsSticky(true)
            } else {
                setIsSticky(false)
            }
        }

        window.addEventListener("scroll", handleScroll)

        return () => {
            window.removeEventListener("scroll", handleScroll)
        }
    }, [])

    return (
        <>
            <div ref={placeholderRef} style={{ height: isSticky ? notReadyToBookRef.current?.offsetHeight : "auto" }} />
            <div ref={notReadyToBookRef}>
                <InnerSectionContainer
                    className={clsx(styles.container, {
                        [styles.withBorder]: withBorder,
                        [styles.sticky]: isSticky,
                    })}
                    wrapperClassName={clsx({ [styles.spacingBottom]: spacingBottom })}
                    dataContentName={dataContentName}
                    spacingBottom={null}
                    spacingTop={null}
                >
                    <div className={styles.content}>
                        <Icon name={iconName} size="2x" padding="inline" className={styles.icon} />
                        <span>{children}</span>
                    </div>
                    {button && <div className={styles.button}>{button}</div>}
                </InnerSectionContainer>
            </div>
        </>
    )
}

export default PageBanner
